export interface SelectableTenant {
  id: number
  name: string
  environment: string
}

export interface TenantGroup {
  environment: string
  tenants: SelectableTenant[]
}

// Ordem de prioridade dos ambientes (prod primeiro); demais vão pro fim, alfabético.
const ENV_ORDER = ['prd', 'hml', 'qa', 'dev', 'stg']

/** Prioridade do ambiente. Exportada para que a lista de escopo das restrições
 *  (`capScopeOptions`) use a MESMA ordem — duas ordens divergiriam na mesma tela. */
export function envRank(env: string): number {
  const i = ENV_ORDER.indexOf(env.toLowerCase())
  return i === -1 ? ENV_ORDER.length : i
}

const NO_ENV = '(sem ambiente)'

/**
 * Agrupa tenants por AMBIENTE (campo real `environment`) — substitui a heurística
 * frágil de derivar "org" do nome via split('-') (UX-M2). Filtra por nome OU
 * ambiente (case-insensitive). Grupos ordenados por prioridade de ambiente;
 * tenants ordenados por nome (pt-BR).
 */
export function groupTenantsByEnvironment(
  tenants: SelectableTenant[],
  filter = '',
): TenantGroup[] {
  const q = filter.trim().toLowerCase()
  const filtered = q
    ? tenants.filter(
        (t) =>
          t.name.toLowerCase().includes(q) ||
          (t.environment ?? '').toLowerCase().includes(q),
      )
    : tenants

  const groups = new Map<string, SelectableTenant[]>()
  for (const t of filtered) {
    const env = t.environment || NO_ENV
    const arr = groups.get(env)
    if (arr) arr.push(t)
    else groups.set(env, [t])
  }

  return [...groups.entries()]
    .map(([environment, ts]) => ({
      environment,
      tenants: [...ts].sort((a, b) => a.name.localeCompare(b.name, 'pt-BR')),
    }))
    .sort(
      (a, b) =>
        envRank(a.environment) - envRank(b.environment) ||
        a.environment.localeCompare(b.environment),
    )
}
